import { render, staticRenderFns } from "./KExternalLink.vue?vue&type=template&id=84d7fbca&scoped=true&"
import script from "./KExternalLink.vue?vue&type=script&lang=js&"
export * from "./KExternalLink.vue?vue&type=script&lang=js&"
import style0 from "./KExternalLink.vue?vue&type=style&index=0&id=84d7fbca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d7fbca",
  null
  
)

export default component.exports